<!-- page-wrapper Start-->
<div [ngClass]="layout.config.settings.layout_type">
  <div class="page-wrapper" id="canvas-bookmark" [ngClass]="layoutClass">
    <shared-header></shared-header>
    <!-- Page Body Start-->
    <div class="page-body-wrapper">
      <div
        class="sidebar-wrapper"
        [attr.icon]="layout.config.settings.icon"
        [class.close_icon]="navServices.collapseSidebar"
        [ngClass]="{
          'd-flex align-items-center justify-content-center h-100': !(
            profileLoaded$ | async
          )
        }"
      >
        @if (profileLoaded$ |async) {
        <shared-sidebar></shared-sidebar>
        } @else {
        <div class="loader-box">
          <div class="loader-16"></div>
        </div>
        }
      </div>
      <div class="page-body">
        <main [@fadeInAnimation]="getRouterOutletState(o)">
          <router-outlet #o="outlet"></router-outlet>
        </main>
      </div>
      <!-- footer start-->
      <footer class="footer">
        <shared-footer></shared-footer>
      </footer>
      <!-- footer End-->
    </div>
    <!-- Page Body End-->
  </div>
</div>
<div class="bg-overlay1"></div>
<!-- <shared-customizer></shared-customizer> -->
<!-- page-wrapper End-->
